import { render, staticRenderFns } from "./AddProductTag.vue?vue&type=template&id=28cf8fb0&scoped=true&"
import script from "./AddProductTag.vue?vue&type=script&lang=js&"
export * from "./AddProductTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cf8fb0",
  null
  
)

export default component.exports